export const GET_SETTINGS_REQUEST = "GET_SETTINGS_REQUEST"
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS"
export const GET_SETTINGS_FAILURE = "GET_SETTINGS_FAILURE"
